<template>
  <!-- <v-card v-if="error">
    
  </v-card> -->
  <v-card
    :loading="isLoading"
  >
    <v-btn
      v-if="!hideRefresh"
      icon
      absolute
      top
      right
      :loading="isLoading"
      v-on:click="fetch()"
    >
      <v-icon>mdi-refresh</v-icon>
    </v-btn>
    <v-card-title
      v-if="!config.hideTitle && title"
    >
      <!-- <div>{{ !!data && data.length > 0 }}: <span v-if="!!data">{{ data.length }}</span></div> -->
      <div
        class="overline"
        v-text="title"
      />
      <v-spacer />
    </v-card-title>

    <transition name="fade" mode="out-in">
      <j-error-alert
        v-if="error"
        v-model="error"
        v-on:retry="fetch()"
        class="fill-height ma-0"
      />
      <template
        v-if="!data || data.length < 1"
      >
        <div
          v-if="isLoading"
          key="loader"
          class="pa-4 d-flex justify-center align-center"
        >
          <j-loader />
        </div>
        <div
          v-else
          key="no-data"
          class="pa-4 text-center text-secondary"
        >
          no data
        </div>
      </template>
      <div
        v-else
        key="has-data"
        :class="[ 'flex-auto', ...(config.contentClass || []) ]"
      >
        <component
          :is="config.component"
          :data="data"
          v-on:fetch="fetch()"
        />
      </div>
    </transition>
  </v-card>
</template>

<script>
import JErrorAlert from '@/ui/controls/JErrorAlert'

export default {
  components: {
    JErrorAlert,
  },
  props: {
    config: Object,
    // data: [Object, Array],
  },
  data() {
    return {
      data: [],
      titleOverride: undefined,
      isLoading: true, // show loader when mounted
      error: undefined,
    }
  },
  computed: {
    title() {
      return this.titleOverride || this.config.title || 'Unnamed Widget'
    },
    hideRefresh() {
      return !!this.config.hideRefresh
    },
  },
  mounted() {
    this.fetch()
  },
  methods: {
    fetch() {
      this.isLoading = true
      this.error = undefined
      this.config.fetch()
        .then(data => {
          this.data = data
          if (data.title) this.titleOverride = data.title
        })
        .catch(err => {
          this.error = new Error(err.error_description || err.message || 'unknown error')
        })
        .finally(() => this.isLoading = false)
    },
  },
}
</script>

<style lang="scss" scoped>
.v-card {
  display: flex;
  flex-direction: column;
  height: 100%;

  .flex-auto {
    flex: 1 1 auto;
    overflow: hidden;
  }

  .v-btn--absolute {
    &.v-btn--top {
      top: 8px;
    }

    &.v-btn--right {
      right: 8px;
    }

  }
}
</style>